export default __webpack_public_path__ + "static/media/b_slide2.81d74957.jpg";